import React from 'react'
import PropTypes from 'prop-types'
import styles from './hero.module.css'
import Image from 'gatsby-image'
import Nav from './nav'
import { useSiteLogo } from './hero'
import { rhythm } from '../utils/typography'


const BasicHero = ({ headline, useH1, nav }) => (
  <div style={{
    marginLeft: 'auto',
    marginRight: 'auto',
    maxWidth: rhythm(30),
    padding: `${rhythm(1.5)} ${rhythm(3 / 4)}`,
  }}
  >
    {nav && <Nav />}
    <Image 
      fluid={useSiteLogo().childImageSharp.sizes} 
      className={styles.smallLogo} 
      alt="SwitchPal Logo"
    />
    {headline && renderHeadline(headline, useH1)}
  </div>
)

BasicHero.propTypes = {
  headline: PropTypes.string,
  useH1: PropTypes.bool,
  nav: PropTypes.bool,
}

const renderHeadline = (headline, useH1) => {
  return (useH1 && <h1 className={styles.headline}>{headline}</h1>) || <p className={styles.headline}>{headline}</p>
}

export default BasicHero
